import React from "react"
import {AutoComplete, Input, Typography} from "antd"

import ApiService from "../../services/ApiService"
import Link from 'next/link';
import logger from "../../services/logger"

const {Text} = Typography

export default class Searchinput extends React.Component{

    state={
        orgs:[],
        text:""
    }

    async searchOrg()
    {
        const text=this.state.text

        if(text==""){
            this.setState({orgs:[]})
            return false
        }

        var res=await ApiService.get("/organisations/?page=1&search="+text)

        if(res.success)
        {
            this.setState({orgs:res.items})
        }
    }


    render()
    {

        const options=this.state.orgs.map((item,index)=>{
            return {
                data:item,
                value:"",
                label:(
                    <Link href={item.BASE_WEB_URL}>
                        <div style={{display:"flex",alignItems:"center"}}>
                            <img src={item.logo} style={{objectFit:"contain",height:50,width:50}} />

                            <div style={{display:"flex",flexDirection:"column",paddingLeft:"5%"}}>
                                <Text strong>{item.name}</Text>
                                <Text type="secondary">{item.postal} - {item.ville}</Text>
                            </div>

                        </div>
                    </Link>
                )
            }
        })
        logger.debug({ options }, "searchinput options")

        return(
            <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>

                <AutoComplete
                    popupClassName="certain-category-search-dropdown"
                    dropdownMatchSelectWidth={"90%"}
                    style={{ width: "90%",maxWidth:600 }}
                    options={options}
                    onSelect={(v,option)=> {
                        this.setState({text:option.data.name})
                    }}
                >
                    <Input.Search size="large" value={this.state.text} placeholder="Chercher une Association / Ville / Code Postal..." onChange={(e)=>{
                        clearTimeout(this.search)
                        this.search=setTimeout(()=>this.setState({text:e.target.value},()=>this.searchOrg()),500)
                    }} />
                </AutoComplete>

            </div>
        )


    }
}
